import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { useAssignReviewerToDocument, useCurrentDocument } from '../api'

export function useAssignReviewer(onAssigned?: (documentKey: string) => void) {
  const queryClient = useQueryClient()
  const {
    data: { document },
  } = useCurrentDocument()

  const { mutateAsync: assignReviewer, isPending } = useAssignReviewerToDocument()

  // Assign reviewer to document if not assigned
  useEffect(() => {
    const assignReviewerIfNeeded = async () => {
      if (!document.reviewer) {
        await assignReviewer({
          path: {
            key: document.key,
          },
        })

        onAssigned?.(document.key)

        queryClient.invalidateQueries(
          apiClient.getDocumentDocumentsKeyGetOptions({
            path: {
              key: document.key,
            },
          }),
        )
      }
    }
    assignReviewerIfNeeded()
  }, [assignReviewer, document.key, document.reviewer, queryClient, onAssigned])

  return {
    assigningInProgress: isPending || !document.reviewer,
  }
}
